import { GlLink, GlTooltipDirective, GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { getTimeago, localeDateFormat, newDate } from '~/lib/utils/datetime_utility';
import { truncateSha } from '~/lib/utils/text_utility';
import { __, sprintf } from '~/locale';
import ClipboardButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/clipboard_button.vue?vue3';
import ExpandButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/releases/components/expand_button.vue?vue3';
export default {
    name: 'EvidenceBlock',
    components: {
        ClipboardButton,
        ExpandButton,
        GlLink,
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        release: {
            type: Object,
            required: true
        }
    },
    computed: {
        evidences () {
            return this.release.evidences;
        }
    },
    methods: {
        evidenceTitle (index) {
            const [tag, evidence, filename] = this.release.evidences[index].filepath.split('/').slice(-3);
            return sprintf(__('%{tag}-%{evidence}-%{filename}'), {
                tag,
                evidence,
                filename
            });
        },
        evidenceUrl (index) {
            return this.release.evidences[index].filepath;
        },
        sha (index) {
            return this.release.evidences[index].sha;
        },
        shortSha (index) {
            return truncateSha(this.release.evidences[index].sha);
        },
        collectedAt (index) {
            return localeDateFormat.asDateTimeFull.format(newDate(this.release.evidences[index].collectedAt));
        },
        timeSummary (index) {
            const { format } = getTimeago();
            return sprintf(__(' Collected %{time}'), {
                time: format(newDate(this.release.evidences[index].collectedAt))
            });
        }
    }
};
